import { createFileRoute } from "@tanstack/react-router";
import { GoogleLandingPage } from "@/components/pages/GoogleLandingPage";

const SITE = "https://kentro.com.br";

const META = {
  en: {
    title: "Kentro Sistemas Inteligentes | Chat + CRM + AI for WhatsApp",
    desc: "Serve on WhatsApp, organize CRM and sell more with AI. Omnichannel platform with the Official WhatsApp API. Free demo.",
    ogTitle: "Kentro: Chat + CRM + AI for WhatsApp",
    ogDesc: "Centralize WhatsApp, Instagram and CRM in one AI-powered platform. Request a free demo.",
  },
  es: {
    title: "Kentro Sistemas Inteligentes | Chat + CRM + IA para WhatsApp",
    desc: "Atiende en WhatsApp, organiza el CRM y vende más con IA. Plataforma omnicanal con API Oficial de WhatsApp. Demostración gratuita.",
    ogTitle: "Kentro: Chat + CRM + IA para WhatsApp",
    ogDesc: "Centraliza WhatsApp, Instagram y CRM en una plataforma con IA. Solicita una demostración gratuita.",
  },
} as const;

export const Route = createFileRoute("/$locale/google")({
  head: ({ params }) => {
    const loc: "en" | "es" = params.locale === "es" ? "es" : "en";
    const m = META[loc];
    return {
      meta: [
        { title: m.title },
        { name: "description", content: m.desc },
        { property: "og:title", content: m.ogTitle },
        { property: "og:description", content: m.ogDesc },
        { property: "og:url", content: `${SITE}/${loc}/google` },
        { property: "og:locale", content: loc === "es" ? "es_ES" : "en_US" },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/google` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/google` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/google` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/google` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/google` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'Google Ads', item: `${SITE}/${loc}/google` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'WebPage',
            "@id": `${SITE}/${loc}/google`,
            url: `${SITE}/${loc}/google`,
            name: m.title,
            description: m.desc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: GoogleLandingPage,
});
